import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { UIProvider } from './contexts/UIContext';
import { ReportWindowsProvider } from './features/reports/windows/ReportWindowsContext';
import ReportWindowLayer from './features/reports/windows/ReportWindowLayer';
import MainLayout from './layouts/MainLayout';
import AuthLayout from './layouts/AuthLayout';
import PortfolioDetailPage from './features/portfolio/pages/PortfolioDetailPage';
import ReportsPage from './features/reports/pages/ReportsPage';
import MarketPlacePage from './features/marketplace/pages/MarketPlacePage';
import ManualPage from './features/manual/pages/ManualPage';
import InfoPage from './features/info/pages/InfoPage';
import SignInPage from './features/auth/pages/SignInPage';
import SetPasswordPage from './features/auth/pages/SetPasswordPage';
import HomeRoute from './features/landing/HomeRoute';
import './App.css';
import './styles/customScrollbar.css';

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <UIProvider>
          <ReportWindowsProvider>
          <Router>
            <Routes>
              {/* Public routes */}
              <Route element={<AuthLayout />}>
                <Route path="/login" element={<SignInPage />} />
                <Route path="/reset-password" element={<SignInPage />} />
                <Route path="/set-password" element={<SetPasswordPage />} />
              </Route>

              {/* Public landing (or app for authenticated users) */}
              <Route path="/" element={<HomeRoute />} />

              {/* Protected routes */}
              <Route element={<MainLayout />}>
                <Route path="/client/:id" element={<PortfolioDetailPage />} />
                <Route path="/reports" element={<ReportsPage />} />
                <Route path="/marketplace" element={<MarketPlacePage />} />
                <Route path="/manual" element={<ManualPage />} />
                <Route path="/info" element={<InfoPage />} />
              </Route>

              {/* Catch all */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            {/* Floating report windows + taskbar, above all pages */}
            <ReportWindowLayer />
          </Router>
          </ReportWindowsProvider>
        </UIProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
